import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';
import { List as ImmutableList } from 'immutable';

const getStateSlice = (state) => state.api.network.firewall.getBasicOptions;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_FIREWALL_GETBASICOPTIONS',
	method: 'POST',
	url: '/network/firewall/getBasicOptions.json',
});

const selectors = {
	options: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'options'], ImmutableList()),
	),
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
